var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Download Sample")]),_c('button',{on:{"click":_vm.download}},[_vm._v("샘플 파일 다운로드")])])
}
var staticRenderFns = []

export { render, staticRenderFns }